import React, { useEffect, useState } from "react";
import "./quiz.scss";
import Header from "../../../components/Header";
import FooterTwo from "../../../components/Footer/FooterTwo";
import { useParams } from "react-router";
import { formatDate } from "../formatted-date";

const Quiz = () => {
  const [quizData, setQuizData] = useState(null);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const { quizId } = useParams();

  useEffect(() => {
    if (!quizId) return;

    fetch(`/quizzes/${quizId}.json`)
      .then((res) => {
        if (!res.ok) throw new Error("Quiz not found");
        return res.json();
      })
      .then((data) => setQuizData(data))
      .catch((err) => console.log(err.message));
  }, [quizId]);

  console.log("quizData,", quizData);
  const handleAnswerChange = (questionId, option) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: option,
    }));
  };

  const handleSubmit = () => {
    let newScore = 0;
    quizData.questions.forEach((q) => {
      if (answers[q.id] === q.answer) newScore++;
    });
    setScore(newScore);
    setSubmitted(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleRetry = () => {
    setAnswers({});
    setSubmitted(false);
    setScore(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!quizData) return <div className="quiz-loading">Loading quiz...</div>;

  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        topbarEnable="enable"
      />
      <div className="quiz-wrapper">
        <h2 className="quiz-title">
          Current Affairs Quiz : {formatDate(quizId)}
        </h2>

        {submitted && (
          <div className="quiz-score">
            Your Score: {score} / {quizData.questions.length}
          </div>
        )}

        {quizData.questions.map((q, idx) => (
          <div key={q.id} className="quiz-question">
            <p className="question">
              {idx + 1}.{" "}
              <span dangerouslySetInnerHTML={{ __html: q.question }} />
            </p>

            {q.type === "multi-statement" && (
              <ul className="statement-list">
                {q.statements.map((stmt, i) => (
                  <li key={i}>{stmt}</li>
                ))}
              </ul>
            )}

            {q.type === "match-the-following" && (
              <div className="match-section">
                {Object.entries(q).map(([key, value], index) => {
                  // Ignore non-array properties (like id, question, type, etc.)
                  if (
                    !Array.isArray(value) ||
                    key === "options" ||
                    key === "answer" ||
                    key === "explanation"
                  ) {
                    return null;
                  }

                  return (
                    <div key={index}>
                      <strong style={{ display: "block", textAlign: "center" }}>
                        {key}
                      </strong>
                      <ul>
                        {value.length > 0 ? (
                          value.map((item, i) => <li key={i}>{item}</li>)
                        ) : (
                          <li>No items available</li>
                        )}
                      </ul>
                    </div>
                  );
                })}
              </div>
            )}

            {q.type === "assertion-reason" && (
              <div className="assertion-reason">
                <p>
                  <strong>Assertion (A):</strong> {q.assertion}
                </p>
                <p>
                  <strong>Reason (R):</strong> {q.reason}
                </p>
              </div>
            )}

            <div className="options">
              {q.options.map((opt, i) => {
                const isSelected = answers[q.id] === opt;
                const isCorrect = opt === q.answer;
                const isIncorrectSelected = isSelected && !isCorrect;

                return (
                  <label
                    key={i}
                    className={`option-label ${
                      submitted
                        ? isCorrect
                          ? "correct"
                          : isIncorrectSelected
                          ? "wrong"
                          : ""
                        : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name={`q-${q.id}`}
                      value={opt}
                      checked={isSelected}
                      onChange={() => handleAnswerChange(q.id, opt)}
                      disabled={submitted}
                    />
                    {opt}
                  </label>
                );
              })}
            </div>

            {submitted && (
              <div
                className={`explanation ${
                  answers[q.id] === q.answer ? "correct" : "wrong"
                }`}
              >
                <strong>Correct Answer:</strong> {q.answer}
                <br />
                <strong>Explanation:</strong>
                <br />
                <span dangerouslySetInnerHTML={{ __html: q.explanation }} />
              </div>
            )}
          </div>
        ))}

        <div className="quiz-controls">
          {!submitted ? (
            <button className="submit-btn" onClick={handleSubmit}>
              Get My Results
            </button>
          ) : (
            <button className="retry-btn" onClick={handleRetry}>
              Retake Quiz
            </button>
          )}
        </div>
      </div>
      <FooterTwo />
    </>
  );
};

export default Quiz;
